/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { themes } from '@theme'
import React, { useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'

import { XCloseIcon } from './Icon'

interface IProps {
  children?: JSX.Element | JSX.Element[] | string
  modalClassName?: string
  contentClassName?: string
  childrenClassName?: string
  title?: string | React.ReactNode
  closeIcon?: React.ReactNode
  haveCloseIcon?: boolean
  overlay?: boolean
  innerModal?: boolean
  borderRadius?: number
  disabledOutsideScroll?: boolean
  open?: boolean
  onClose?: () => void
  avoidClickOutside?: boolean
  popupPosition?: 'top' | 'center'
  backgroundColor?: string
}

export const AppModal = (props: IProps) => {
  const modal = useRef<HTMLDivElement>(null)

  //page props
  const {
    children,
    title,
    modalClassName = '',
    contentClassName = '',
    childrenClassName = '',
    closeIcon,
    haveCloseIcon = false,
    overlay,
    innerModal,
    borderRadius,
    disabledOutsideScroll = true,
    onClose,
    avoidClickOutside = false,
    open,
    popupPosition = 'center',
    backgroundColor,
  } = props
  useEffect(() => {
    const page = document.documentElement
    if (disabledOutsideScroll) {
      page.style.overflowY = 'hidden'
    }
    return () => {
      page.style.overflowY = 'auto'
    }
  }, [])

  return (
    <StyledModal
      className={modalClassName ? `${modalClassName} app-modal` : 'app-modal'}
      $overlay={overlay}
      $innerModal={innerModal}
      $borderRadius={borderRadius}
      $popupPosition={popupPosition}
      $open={open}
      $backgroundColor={backgroundColor}
      $hasTitle={!!title}
    >
      <div
        style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 40px)' }}
        className={`content ${contentClassName}`}
        ref={modal}
      >
        <div
          className="modal_title_container"
          hidden={!title && !haveCloseIcon}
        >
          {title && <h2 className="modal__title">{title}</h2>}
          {haveCloseIcon && (
            <div className="modal__close" onClick={onClose}>
              {closeIcon || <XCloseIcon width={16} height={16} />}
            </div>
          )}
        </div>

        <div className={`mt-8 ${childrenClassName}`}>{children}</div>
      </div>
    </StyledModal>
  )
}

const StyledModal = styled.div<{
  $overlay?: boolean
  $innerModal?: boolean
  $borderRadius?: number
  $popupPosition?: 'top' | 'center'
  $open?: boolean
  $backgroundColor?: string
  $hasTitle?: boolean
}>`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: ${(p) =>
    p?.$popupPosition === 'top' ? 'flex-start' : 'center'};
  z-index: 100;
  ${(p) =>
    p.$open
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}
  ${(p) =>
    p.$overlay &&
    css`
      background: rgba(0, 0, 0, 0.1);
    `}
  ${(p) =>
    p.$innerModal &&
    css`
      position: absolute;
    `}
  .content {
    position: relative;
    width: fit-content;
    height: fit-content;
    padding: 2.6rem 3.2rem;
    padding-top: 0;
    justify-content: center;
    align-items: center;
    background: ${(p) =>
      p.$backgroundColor
        ? p.$backgroundColor
        : themes.theme.light.colors.bgSection};
    box-shadow: 0.2rem 0.2rem 1rem 0.4rem rgba(208, 208, 208, 0.25);
    ${(p) =>
      p.$open
        ? css`
            margin-top: ${p?.$popupPosition === 'top' ? '2.3rem' : '0'};
          `
        : css`
            margin-top: -100vh;
          `}
    min-width: 18rem;
    transition: all 0.4s;
    border-radius: ${(p) =>
      !p.$borderRadius ? '0.6rem' : `${p.$borderRadius}px`};
    .modal__close {
      cursor: pointer;
      &:hover {
        opacity: 0.6;
      }
    }

    .modal_title_container {
      width: 100%;
      display: flex;
      justify-content: ${({ $hasTitle }) =>
        $hasTitle ? 'space-between' : 'flex-end'};
      align-items: flex-start;
      position: sticky;
      top: 0;
      left: 0;
      background: white;
      padding-top: 2.6rem;
      z-index: 20;
    }

    .modal__title {
      width: 100%;
      text-align: start;
      font-weight: 500;
      font-size: 1.5rem;
    }
  }
`
